module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/04e2bd07d449e5c4901edef9fbec5113.png";